const topics = [
  { name: '星辰大海', heat: '9.8', tag: '热播中' },
  { name: '榴莲视频', heat: '9.7', tag: '热门' },
  { name: '红杏视频', heat: '9.6', tag: '推荐' },
  { name: '悬疑剧场', heat: '9.5', tag: '热播中' },
  { name: '古装大剧', heat: '9.4', tag: '热门' },
  { name: '4K超清', heat: '9.3', tag: '新上' },
  { name: '综艺娱乐', heat: '9.2', tag: '推荐' },
  { name: '国漫崛起', heat: '9.1', tag: '热门' },
  { name: '院线大片', heat: '9.0', tag: '热播中' },
  { name: '经典重温', heat: '8.9', tag: '推荐' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium mb-4">
            热门话题
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            话题热度榜
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            向日葵视频用户最关注的热门影视话题，看看大家都在讨论什么
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((item, idx) => (
            <a
              key={idx}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className="group flex items-center gap-3 px-5 py-3 rounded-full bg-background-100 border border-background-200/60 hover:border-primary-300 hover:bg-primary-50/60 transition-all duration-300 cursor-pointer"
            >
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-xs font-bold">
                {idx + 1}
              </span>
              <div>
                <div className="flex items-center gap-2">
                  <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">
                    {item.name}
                  </span>
                  <span className="text-xs px-1.5 py-0.5 rounded bg-accent-100/80 text-accent-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="flex items-center gap-1 mt-0.5">
                  <i className="ri-fire-line text-accent-500 text-xs"></i>
                  <span className="text-xs text-accent-600 font-medium">{item.heat}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}